import React from 'react'
import { object, func } from 'prop-types'
import BigCard from './BigCard'
import CircuitPopup from '../CircuitPopup/CircuitPopup'
import Strava from '../Strava/Strava'
import Icons from '../Icons/Icon'
import { translateSport, translateGround, translateType, translateMonth } from '../../helpers/helpers'

import FaEye from 'react-icons/lib/fa/eye'
import FaEdit from 'react-icons/lib/fa/edit'
import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left'
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right'

import styles from './TableDay.styl'

export default class TableDay extends React.Component {

	static propTypes = {
		date: object,
		location: object,
		workout: object,
		changeDate: func,
		fetchAction: func
	}

	// static getDerivedStateFromProps(nextProps, nextState) {
	// 	const { date, workout } = nextProps
	// 	return {
	// 		workout: workout || { currentParams: {} },
	// 		title: `${ date.getDate() } de ${ translateMonth[date.getMonth()] }`
	// 	}
	// }

	constructor(props) {
		super(props)
		const { date, workout } = props
		this.state = { workout: workout || { currentParams: {} }, title: `${ date.date() } de ${ translateMonth[date.month()] }`, strava: false, exerciseDisplay: { state: false } }
	}
	componentWillReceiveProps(nextProps) {
		const { date, workout } = nextProps
		this.setState({
			workout: workout || { currentParams: {} },
			title: `${ date.date() } de ${ translateMonth[date.month()] }`
		})
	}
	handleWorkoutUpdate(data) {
		this.setState(prevState => ({ workout: { ...prevState.workout, ...data } }))
	}
	render() {
		const { changeDate, fetchAction } = this.props
		const { title, strava, exerciseDisplay, workout } = this.state
		return (
			<div className={ styles['workout-container'] }>
				{ exerciseDisplay.state ? <CircuitPopup exercises={ exerciseDisplay.exercises } percentage={ exerciseDisplay.percentage } close={ () => { this.setState({ exerciseDisplay: { state: false } }) } } /> : null }
				{ strava ?
					<Strava
						close={ () => this.setState({ strava: false }) }
						workoutDate={ title }
						fetchAction={ fetchAction }
						updateWorkout={ this.handleWorkoutUpdate.bind(this) }
						workout={ workout }
					/> :
					null
				}
				<div className={ styles['content'] }>
					<div className={ Object.keys(workout).length > 1 ? styles['edit-icon-enabled'] : styles['edit-icon-disabled'] }>
						<FaEdit
							color="#868686" onClick={ () => {
								if (Object.keys(workout).length > 1) {
									this.setState({ strava: true })
								}
							} }
						/>
					</div>
					<div className={ styles['title-container'] }>
						<div
							className={ styles.arrow } onClick={ () => {
								changeDate(-1)
							} }
						><FaArrowCircleLeft /></div>
						<div className={ styles.titleDiv }>
							{ workout.priority === 'primary' ?
								<h3>{ title } <strong>{ workout.priority === 'primary' && workout.type ? `(UT ${ translateType(workout.type) })` : null }</strong></h3> :
								<h3>{ title } <strong>{ workout.priority === 'secondary' ? '(Treino Secundário)' : null }</strong></h3>
							}
						</div>
						<div
							className={ styles.arrow } onClick={ () => {
								changeDate(1)
							} }
						><FaArrowCircleRight /></div>
					</div>

					<div className={ styles['metrics-container'] }>
						<div className={ styles.smallBoxRow }>
							<div className={ styles.box }>
								<p>Tipo de Treino</p>
								<p>{ workout.sport ? <i className={ styles.typeIcon }><Icons name={ translateSport(workout.sport) } /></i> : '--' }</p>
							</div>
							<div className={ styles.box }>
								<p>Objectivo - UT</p>
								<p>{ workout.goal ? workout.goal.name : '--' }</p>
							</div>
							<div className={ styles.box }>
								<p>Terreno</p>
								<p style={ { textTransform: 'capitalize' } }>{ workout.ground ? workout.ground.name : '--' }</p>
							</div>
							<div className={ styles.box }>
								<p>Altimetria</p>
								<p>{ workout.slope ? workout.slope.name : '--' }</p>
							</div>
						</div>
						<div className={ styles.bigBoxRow }>
							{ workout.goal && workout.goal.name === 'PA' ?
								<BigCard
									serie={ workout.serie }
									recoveryBPM={ workout.currentParams.recoveryBPM }
									maxBPM={ workout.currentParams.averageBPM }
									isPA
									title="SÉRIE"
									unit="min"
									value={ workout.serie ? `${ workout.serie.repetitions } x (${ workout.serie.accelerationTime } + ${ workout.serie.time } + ${ workout.serie.recoveryTime })` : '--' }
									valueUT={ workout.athleteParams ? workout.athleteParams.time : null }
								/> : <BigCard title="TEMPO PRESCRITO" unit="min" value={ workout.currentParams.time || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.time : null } />
							}
							<BigCard title="DISTÂNCIA" unit="km" value={ workout.currentParams.distance || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.distance : null } />
							<BigCard title="VEL. MÉDIA" unit="km/h" value={ workout.currentParams.averageSpeed || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.averageSpeed : null } />
							<BigCard title="RITMO" unit="mim/km" value={ workout.currentParams.pace || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.pace : null } />
							<BigCard title="FC MÉDIA" unit="ppm" value={ workout.currentParams.averageBPM || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.averageBPM : null } />
							<BigCard title="FC MÁXIMA" unit="ppm" value={ workout.currentParams.maxBPM || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.maxBPM : null } />
							{ workout.goal && workout.goal.name === 'PA' ? <BigCard title="FC RECUPERAÇÃO" unit="ppm" value={ workout.currentParams.recoveryBPM || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.recoveryBPM : null } /> : null }
							<BigCard title="CALORIAS" unit="cal" value={ workout.currentParams.calories || '--' } valueUT={ workout.athleteParams ? workout.athleteParams.calories : null } />
							{/* <BigCard title="DESNÍVEL ACUMULADO" unit="m" value={workout.currentParams.DA || '--'} valueUT={workout.athleteParams ? workout.athleteParams.DP : null} /> */ }
						</div>
					</div>
				</div>
				<div className={ styles.circuits }>
					<div className={ styles.circuitsRow }>
						<div className={ styles.box }>MUSCULAÇÃO</div>
						<div className={ styles.box }>
							<p>{ workout.weightWorkout ? `${ workout.weightWorkoutInfo.reps } x ${ workout.weightWorkout.name }` : '--' }</p>
							<FaEye
								color={ workout.weightWorkout ? '#eb6800' : '#e3e3e3' }
								height="20px"
								width="20px"
								onClick={ () => {
									if (!workout.weightWorkout) { return }
									this.setState({ exerciseDisplay: { state: true, exercises: workout.weightWorkout.exercises, percentage: workout.weightWorkoutInfo.percentage } })
								} }
							/>
						</div>
					</div>
					<div className={ styles.circuitsRow }>
						<div className={ styles.box }>FLEXIBILIDADE</div>
						<div className={ styles.box }>
							<p>{ workout.flexWorkout ? `${ workout.flexWorkoutInfo.reps } x ${ workout.flexWorkout.name }` : '--' }</p>
							<FaEye
								color={ workout.flexWorkout ? '#eb6800' : '#e3e3e3' }
								height="20px"
								width="20px"
								onClick={ () => {
									if (!workout.flexWorkout) { return }
									this.setState({ exerciseDisplay: { state: true, exercises: workout.flexWorkout.exercises, percentage: workout.flexWorkoutInfo.percentage } })
								} }
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Table/TableDay.js